<template>
  <v-app>
    <v-main>
      <v-theme-provider root>
        <v-container
          class="pa-0 fill-height"
          fluid
        >
          <v-row class="fill-height ma-0 justify-center align-center">
            <v-col class="col-12 col-md-6 col-lg-4 px-10">
              <v-slide-x-transition mode="out-in">
                <router-view />
              </v-slide-x-transition>

              <!-- <div class="mt-10 text-center">
                <img
                  alt="powered-by-img"
                  height="35px"
                  :src="poweredByLogo"
                />
              </div> -->
            </v-col>
            <v-col class="bg-cover fill-height hidden-xs-only hidden-sm-only md-6 lg-8" />
          </v-row>
        </v-container>
      </v-theme-provider>
    </v-main>

    <SnackBar />
  </v-app>
</template>

<script>
export default {
  components: {
    SnackBar: () => import("@/components/utils/ErrorHandler.vue")
  },
  data() {
    return {
      poweredByLogo: this.$appConfig.assets.img.custom.poweredBy
    }
  }
}
</script>
<style scoped lang="scss">
.bg-cover {
  background-size: cover;
  background-position: 100%;
  background-image: url(../../assets/img/common/cover-4.jpg);
}
</style>
